<div class="d-flex align-items-center">
<ul ngbNav #nav="ngbNav" class="nav-tabs">
	<li ngbNavItem>
		<a ngbNavLink>{{name}}</a>
		<ng-template ngbNavContent>
            <form [class.scroll-x]="scrollX">
                <ng-content></ng-content>
            </form>
		</ng-template>
	</li>
</ul>
@if (showEditModeSwitch && bp) {
	<div class="btn-group btn-group-sm ms-2" role="group" aria-label="Editier-Modus">
		@if (canBeBearbeiter && showEditModeSwitch) {
			<button type="button"
				class="btn"
				[class.btn-secondary]="editModeValue === 'edit'"
				[class.btn-outline-secondary]="editModeValue !== 'edit'"
				title="Bearbeiter-Modus — Feld-Daten editieren, keine Kommentier-Werkzeuge"
				(click)="switchEditMode('edit')">
				<i class="bi bi-pencil"></i><span class="d-none d-lg-inline ms-1">Bearbeiter-Modus</span>
			</button>
		}
		@if (canReview) {
			<button type="button"
				class="btn"
				[class.btn-info]="editModeValue === 'review'"
				[class.btn-outline-info]="editModeValue !== 'review'"
				title="Kontrolleur-Modus — Kommentar-Stift aktiv, Resolve-/Severity-Buttons sichtbar"
				(click)="switchEditMode('review')">
				<i class="bi bi-eye"></i><span class="d-none d-lg-inline ms-1">Kontrolleur-Modus</span>
			</button>
		}
		@if (canCorrect) {
			<button type="button"
				class="btn"
				[class.btn-warning]="editModeValue === 'correct'"
				[class.btn-outline-warning]="editModeValue !== 'correct'"
				title="Korrektur-Modus — Felder direkt editieren; jede Änderung wird automatisch in der Workflow-Historie protokolliert"
				(click)="switchEditMode('correct')">
				<i class="bi bi-pencil"></i><span class="d-none d-lg-inline ms-1">Korrigieren</span>
			</button>
		}
	</div>
}
@if (canReview && editModeValue === 'review' && bp) {
	<div class="btn-group btn-group-sm ms-2" role="group" aria-label="Kommentar-Werkzeuge">
		<button type="button" class="btn"
			[class.btn-danger]="aus.pen === 'danger'"
			[class.btn-outline-danger]="aus.pen !== 'danger'"
			(click)="aus.pen = 'danger'" title="Fehler markieren">
			<i class="bi bi-pen"></i>
		</button>
		<button type="button" class="btn"
			[class.btn-warning]="aus.pen === 'warning'"
			[class.btn-outline-warning]="aus.pen !== 'warning'"
			(click)="aus.pen = 'warning'" title="Warnung markieren">
			<i class="bi bi-pen"></i>
		</button>
		<button type="button" class="btn"
			[class.btn-secondary]="aus.pen === 'message'"
			[class.btn-outline-secondary]="aus.pen !== 'message'"
			(click)="aus.pen = 'message'" title="Neutraler Kommentar">
			<i class="bi bi-pen"></i>
		</button>
		<button type="button" class="btn"
			[class.btn-dark]="aus.pen === 'rubber'"
			[class.btn-outline-dark]="aus.pen !== 'rubber'"
			(click)="aus.pen = 'rubber'" title="Kommentar löschen">
			<i class="bi bi-eraser"></i>
		</button>
	</div>
}
<!-- Protokoll-Info -->
<span class="protocol-info ms-auto me-3" *ngIf="bp">
	<img *ngIf="!istPunktartOhneSymbol(bp.type)" [src]="punktartSvgUrl(bp.type)" alt="" class="protocol-type-icon">
	<span *ngIf="istPunktartOhneSymbol(bp.type)" class="protocol-type-label" title="Punktart ohne Symbol" [style.color]="punktartOhneSymbolColor(bp.type)">[{{ punktartOhneSymbolLabel(bp.type) }}]</span>
	<span class="protocol-nummer">{{ bp.header?.nummer || '–' }}</span>
	<span class="protocol-separator">|</span>
	<!-- Kartierer/Datum wie in der Reiter-Kopfzeile fuer Datennutzer verborgen (Gastmodus, 06.09.2026) -->
	<span class="protocol-detail">{{ (bp.header?.aufnahme?.kartierer || '–') | maskForGuest }}</span>
	<span class="protocol-separator">|</span>
	<span class="protocol-detail">{{ (dateString(bp.header?.aufnahme?.datum) || '–') | maskForGuest }}</span>
</span>
</div>
<div [ngbNavOutlet]="nav"></div>
